import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { H3 } from 'components/Typography';
import UserProfileHeader from '../UserProfileHeader';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import styles from './styles';
import MediaQuery from 'react-responsive';
import m from 'messages';

class AppBarComponent extends React.Component {

    onTabChanged = (event, value) => {
        this.props.history.push(value);
    };

    render() {

        const { classes, cardCheckerCard, shortTitle, longTitle } = this.props;
        const isLoggedIn = Boolean(cardCheckerCard);
        const canSwipeCards = isLoggedIn && !cardCheckerCard.displayOnly && (cardCheckerCard.canSwipeCards);
        const canSpotCheck = isLoggedIn && !cardCheckerCard.displayOnly && (cardCheckerCard.canPerformSpotCheck);
        const canAward = canSwipeCards;

        const currentPath = window.location.pathname;

        return (
            <AppBar>
                <MediaQuery maxWidth={767}>
                    {(isMobile) =>
                        <Toolbar disableGutters={false} className={classes.toolbar}>
                            <Grid container>
                                <Grid item>
                                    <H3 color="inherit" noWrap className={classes.appBarTitle}>
                                        {isMobile ? shortTitle : longTitle}
                                    </H3>
                                </Grid>
                                <div className={classes.grow} />
                                <Grid item>
                                    <UserProfileHeader
                                        onLogOutClicked={this.props.onLogOutClicked}
                                        onLocationClicked={this.props.onLocationClicked}
                                        onCompetencyRequirementsClicked={this.props.onCompetencyRequirementsClicked}
                                        onShowCardClicked={this.props.onShowCardClicked}
                                        cardCheckerCard={this.props.cardCheckerCard}
                                    />
                                </Grid>
                                {isLoggedIn &&
                                    <Grid item xs={12}>
                                        <Tabs
                                            onChange={this.onTabChanged}
                                            value={currentPath}
                                            className={classes.tabs}
                                            variant={isMobile ? 'fullWidth' : 'standard'}>

                                            {canSwipeCards &&
                                                <Tab label={m.swipes._self} value="/" />
                                            }
                                            {canSpotCheck &&
                                                <Tab label={m.spotCheck._self} value="/spotCheck" />
                                            }
                                            {canAward &&
                                                <Tab label={m.competencies._self} value="/competencies" />
                                            }
                                        </Tabs>
                                    </Grid>
                                }
                            </Grid>
                        </Toolbar>
                    }
                </MediaQuery>
            </AppBar>
        );
    }
}

AppBarComponent.propTypes = {
    onLogOutClicked: PropTypes.func.isRequired,
    onLocationClicked: PropTypes.func.isRequired,
    onShowCardClicked: PropTypes.func.isRequired,
    onCompetencyRequirementsClicked: PropTypes.func.isRequired,
    cardCheckerCard: PropTypes.object,
    actionButton: PropTypes.object,
    baseTitle: PropTypes.string,
    title: PropTypes.string,
    menuVisible: PropTypes.bool,
    onMenuClicked: PropTypes.func,
    longTitle: PropTypes.string,
    shortTitle: PropTypes.string
};

const StyledBar = withRouter(withStyles(styles)(AppBarComponent));
export default StyledBar;